"use client";

import { useEffect } from "react";
import { CONNECT_POPUP_NAMES } from "@/lib/connect-popup";

// Provider status params the backend appends on the callback redirect.
const RETURN_PARAMS = ["github", "slack", "gmail", "calendar", "google-drive", "jira", "linear", "figma", "dropbox", "zoom", "asana", "trello", "box", "clickup", "pagerduty", "notion", "gitlab", "confluence", "onedrive", "sentry", "salesforce", "teams", "outlook", "intercom"];

/**
 * Mounted once at the app root. When the page is our connect popup returning
 * from a provider, it closes the popup. No-op on a normal page load. The opener
 * tab notices the close and refreshes its connection statuses.
 */
export default function ConnectPopupBridge() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);
    if (!RETURN_PARAMS.some((p) => params.has(p))) return;

    // Recognize our popup via window.opener, or window.name (survives COOP).
    const isOurPopup =
      (!!window.opener && window.opener !== window) ||
      (CONNECT_POPUP_NAMES as readonly string[]).includes(window.name);

    if (isOurPopup) window.close();
  }, []);

  return null;
}
